export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.8444e461.png";